import {Pipe, PipeTransform} from '@angular/core';
import {contextColors} from '../theme-colors';

@Pipe({name: 'color'})
export class ColorPipe implements PipeTransform {
    transform(input: string): string {
        return contextColors[input];
    }
}
